import React from 'react'
import Content from '../@react-fefmwk/theme-structure/modules/Content'

import SharedDocs from '../modules/SharedDocs'

class SharedDocsPage extends React.Component {
    render() {
        const title = this.props.route.title

        return <Content title={title}>
            <SharedDocs />
        </Content>
    }
}

export default SharedDocsPage